import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPigletManureStorage, getFootprintingPigletManureStorageAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PIGLET_MANURE_STORAGE } from "consts";

export const useGetFootprintingPigletManureStorage = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PIGLET_MANURE_STORAGE, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingPigletManureStorageAdmin(primaryDataId ?? "") : getFootprintingPigletManureStorage(primaryDataId ?? "")),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
